<template>
  <b-modal
    id="edit-user-modal"
    centered
    size="lg"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    dialog-class="my-dialog-class"
  >
    <template #modal-title> <h2 class="m-0">Edit User</h2> </template>
    <validation-observer ref="editUserFormValidation">
      <b-form @submit.prevent>
        <b-form-row>
          <b-col md="6">
            <b-form-group label-for="name">
              <template #label>
                Name <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Name"
                :rules="{ required }"
              >
                <b-form-input
                  id="name"
                  v-model="name"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <VueSelectPaginated
              placeholder="Role"
              name="Role"
              label="name"
              rules="required"
              searchBy="name"
              :prevSelected="role"
              :getListMethod="getRoles"
              @setMethod="
                (value) => {
                  role = value;
                }
              "
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col md="6">
            <b-form-group label-for="coins">
              <template #label>
                Coins <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Coins"
                rules="required"
              >
                <b-form-input
                  id="coins"
                  v-model="coins"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Coins"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="isBoosterEnabledCheckBox">
              <template #label> Is Booster Enabled </template>
              <b-form-checkbox
                v-model="isBoosterEnabled"
                id="isBoosterEnabledCheckBox"
                switch
              >
                {{ isBoosterEnabled }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col md="6">
            <b-form-group label-for="isRateCheckBox">
              <template #label> Is Rate </template>
              <b-form-checkbox v-model="isRate" id="isRateCheckBox" switch>
                {{ isRate }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="isShareCheckBox">
              <template #label> Is Share </template>
              <b-form-checkbox v-model="isShare" id="isShareCheckBox" switch>
                {{ isShare }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-form-row>
      </b-form>
    </validation-observer>
    <template #modal-footer>
      <b-form-group class="text-right">
        <b-button type="submit" variant="info" pill @click="validationForm">
          Update
        </b-button>
      </b-form-group>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import { required } from "@validations";
import util from "@/util.js";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    VueSelectPaginated,
  },
  props: {
    user: Object,
  },
  mixins: [util],
  data() {
    return {
      required,
      name: "",
      coins: "",
      role: null,
      isBoosterEnabled: false,
      isRate: false,
      isShare: false,
    };
  },
  async mounted() {
    if (this.user) {
      this.name = this.user.name;
      this.role = this.user.role_data;
      this.coins = this.user.coins;
      this.isBoosterEnabled = this.user.is_booster_enabled;
      this.isShare = this.user.is_share;
      this.isRate = this.user.is_rate;
    }
  },
  methods: {
    ...mapActions({
      updateUser: "appData/updateUser",
      getRoles: "appData/getRoles",
    }),
    async validationForm() {
      const success = await this.$refs.editUserFormValidation.validate();
      if (success) {
        await this.submit();
      }
    },
    async submit() {
      try {
        const res = await this.updateUser({
          payload: {
            name: this.name,
            coins: this.coins,
            role: this.role.id,
            updated_by: this.getLoggedInUser.id,
            is_booster_enabled: this.isBoosterEnabled,
            is_share: this.isShare,
            is_rate: this.isRate,
          },
          pk: this.user.id,
        });
        if (res.status === 200) {
          this.$swal({
            title: "User updated successfully",
            icon: "success",
          });
          this.$nextTick(() => {
            this.$bvModal.hide("edit-user-modal");
          });
          this.$emit("modalClosed");
        }
      } catch (error) {
        this.displayError(error);
      }
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
  },
};
</script>

<style></style>
